import { BaseTable, Loading, TableHeader } from "components";
import { useListDataPost } from "../../utils";
import moment from "moment";
import { APPROVAL, convertNumber } from "utils";
import { PaymentType } from "pages/Card/Transaction/CreateNewVendor/types";

export function Payment(props: {
    dateFrom: string
    dateTo: string
    approval?: string
    vendorId: number,
}) {

    const { data, isLoading } = useListDataPost<PaymentType>("payment", {
            DateFrom: props.dateFrom,
            DateEnd: props.dateTo,
            Approval: props.approval,
            VendorID: props.vendorId
        })

    const totalDeposit = data.reduce((total, item) => total + Number(item.deposit_amount), 0)
    const totalPaymentAmount = data.reduce((total, item) => total + Number(item.payment_amount), 0)
    const totalPayment = data.reduce((total, item) => total + Number(item.deposit_amount) + Number(item.payment_amount), 0)

    return (
        <div>
            <div className="overflow-x-auto mt-12 max-h-[700px]">
                <BaseTable className="border-collapse">
                    <TableHeader>
                        <tr>
                            <th>NO</th>
                            <th>PAYMENT BILL ID</th>
                            <th>BILL ID</th>
                            <th>DATE</th>
                            <th>APPROVAL</th>
                            <th>MEMO</th>
                            <th>DEPOSIT AMOUNT</th>
                            <th>PAYMENT AMOUNT</th>
                            <th>TOTAL PAYMENT</th>
                        </tr>
                    </TableHeader>
                    <tbody>
                        {isLoading || !data.length ? (
                            <tr>
                                <td colSpan={9}>
                                    <div className="w-full flex justify-center items-center">
                                        <Loading loading={isLoading} errorText={isLoading ? "" : "No data available"} />
                                    </div>
                                </td>
                            </tr>
                        ) : (
                            data.map((item, index: number) => {
                                const totalPayment = Number(item.deposit_amount) + Number(item.payment_amount)

                                return (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item.trx_code}</td>
                                        <td>{item.billcode}</td>
                                        <td>{item.transaction_date ? moment(item.transaction_date).format("DD/MM/YYYY") : ""}</td>
                                        <td>{APPROVAL[item.approve_status]}</td>
                                        <td>{item.memo}</td>
                                        <td className="text-right">{item.deposit_amount ? convertNumber(Number(item.deposit_amount)).intoCurrency : ""}</td>
                                        <td className="text-right">{item.payment_amount ? convertNumber(Number(item.payment_amount)).intoCurrency : ""}</td>
                                        <td className="text-right">
                                            {totalPayment ? convertNumber(totalPayment).intoCurrency : ""}
                                        </td>
                                    </tr>
                                )
                            }
                            )
                        )}
                    </tbody>
                </BaseTable>
            </div>
            <div className="mt-2 flex justify-end font-bold">
                <div className="flex flex-col gap-2">
                    <div className="flex">
                        <span className="mr-2 w-[200px]">Total Deposit Amount</span>
                        <span>:</span>
                        <span className="text-right ml-2">{totalDeposit ? convertNumber(totalDeposit).intoCurrency : "0"}</span>
                    </div>
                    <div className="flex">
                        <span className="mr-2 w-[200px]">Total Payment Amount</span>
                        <span>:</span>
                        <span className="text-right ml-2">{totalPaymentAmount ? convertNumber(totalPaymentAmount).intoCurrency : "0"}</span>
                    </div>
                    <div className="flex">
                        <span className="mr-2 w-[200px]">Total Payment</span>
                        <span>:</span>
                        <span className="text-right ml-2">{totalPayment ? convertNumber(totalPayment).intoCurrency : "0"}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}